import CryptogramGame from '../components/CryptogramGame';

export default function Kryptogramms() {
  return <CryptogramGame />;
}
